import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Modal from "common/components/Modal/Modal"
import { formatDate } from "common/utils/date"
import {
  getDocumentLabel,
  MODES_DOCUMENTOS,
  TYPES_DOCUMENTOS,
} from "features/Crear/pages/FormCreacionDocumento/constant"
import { FormikDocumentsProps } from "features/Crear/pages/FormCreacionDocumento/CreacionDocumento"
import { capitalize } from "features/User/utils"
import { AnimatePresence } from "framer-motion"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { useTranslation } from "react-i18next"
import FormFechaEmision from "../../Forms/FechaEmisionDocument/FechaEmisionDocument"
import FormFechaPagoOperacion from "../../Forms/FechaOperacionesDocument/FechaOperacionesDocument"
import FormFechaVencimiento from "../../Forms/FechaVencimientoDocument/FechaVencimientoDocument"

const SERIES_OPTIONS: string[] = "ABCDEFGHIJKLMNÑOPQRSTUVWXYZ".split("")

const HeaderDatesLogoDocument = ({
  values,
  setFieldValue,
}: FormikDocumentsProps) => {
  const { t } = useTranslation()
  const isCompra = values?.config?.esCompraArticulos

  return (
    <div className='tw-flex tw-justify-between tw-flex-col sm:tw-flex-row '>
      <div
        className={`tw-flex tw-flex-col ${
          values.documentoType.type === TYPES_DOCUMENTOS.PROFORMA
            ? "tw-w-52"
            : "tw-w-40"
        } `}
      >
        {values.logoAsBase64 && (
          <img
            style={{
              maxHeight: "56px",
              objectFit: "contain",
            }}
            src={values.logoAsBase64}
            alt={`${t("crear.facturaRec.logoFacLabel")}`}
            className='tw-mr-3 tw-w-fit'
          />
        )}
        <div
          className={`tw-w-full tw-text-left tw-text-2xl tw-whitespace-nowrap ${
            values.documentoType.type !== TYPES_DOCUMENTOS.PROFORMA && "tw-mt-4"
          } `}
        >
          {capitalize(getDocumentLabel(values.documentoType.type, t))}
        </div>
      </div>
      <div
        className={`tw-flex tw-flex-col tw-w-auto tw-items-end  ${
          values.documentoType.type === TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA
            ? "tw-justify-end"
            : ""
        }`}
      >
        <div className='tw-flex tw-flex-row tw-items-center tw-mb-2.5'>
          {!isCompra ? (
            <>
              {values.documentoType.type ===
              TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA ? null : values
                  .documentoType.type === TYPES_DOCUMENTOS.PROFORMA ? (
                <div className='tw-flex tw-items-center tw-gap-2'>
                  <label
                    className='tw-m-0'
                    htmlFor='titulo'
                  >
                    {t("crear.facturaRec.modal.documentNumberLabel")}:
                  </label>
                  <InputText
                    autoFocus
                    id='numeroDocumento'
                    name='numeroDocumento'
                    placeholder={`${t("newDoc.facturaProforma.placeHolder")}`}
                    value={values.numeroDocumento}
                    onChange={(e) =>
                      setFieldValue("numeroDocumento", e.target.value)
                    }
                  />
                </div>
              ) : (
                <div className='tw-flex tw-items-center tw-gap-2'>
                  <label
                    className='tw-m-0'
                    htmlFor='titulo'
                  >
                    {t("crear.facturaRec.modal.serieLabel")}:
                  </label>
                  <Dropdown
                    className='tw-w-40'
                    id='serie'
                    name='serie'
                    options={SERIES_OPTIONS}
                    value={values.serie}
                    onChange={(e) => {
                      setFieldValue("serie", e.value)
                    }}
                  />
                </div>
              )}
            </>
          ) : (
            <div className='tw-flex tw-items-center tw-gap-2'>
              <label
                className='tw-m-0'
                htmlFor='titulo'
              >
                {t("crear.facturaRec.modal.documentNumberLabel")}:
              </label>
              <InputText
                autoFocus
                id='serie'
                name='serie'
                value={values.serie}
                onChange={(e) => setFieldValue("serie", e.target.value)}
              />
            </div>
          )}
        </div>
        <div className='tw-flex tw-flex-row tw-items-center'>
          {values.documentoType.type !== TYPES_DOCUMENTOS.FACTURA &&
            values.documentoType.type !==
              TYPES_DOCUMENTOS.FACTURA_RECTIFICATIVA && (
              <FontAwesomeIcon
                icon={["fal", "pen"]}
                className='tw-w-4 tw-h-4 tw-text-text !tw-cursor-pointer tw-mr-3 hover:!tw-text-secondary'
                onClick={() =>
                  setFieldValue(
                    "modals.showFechaEmisionModal",
                    !values.modals.showFechaEmisionModal
                  )
                }
              />
            )}
          <p className='tw-m-0 tw-text-base'>
            {t("crear.facturaRec.emisionDateLabel")}
            <span className='tw-font-bold tw-text-base'>
              {formatDate(values.fechaEmision)}
            </span>
          </p>
        </div>
        {values.documentoType.mode === MODES_DOCUMENTOS.VENTA && (
          <div className='tw-flex tw-flex-row tw-items-center'>
            <FontAwesomeIcon
              icon={["fal", "pen"]}
              className='tw-w-4 tw-h-4 tw-text-text !tw-cursor-pointer tw-mr-3 hover:!tw-text-secondary'
              onClick={() =>
                setFieldValue(
                  "modals.showModalFechaVencimiento",
                  !values.modals.showModalFechaVencimiento
                )
              }
            />
            <p className='tw-m-0 tw-text-base'>
              {t("crear.facturaRec.vencimientoDateLabel")}
              <span className='tw-font-bold'>
                {formatDate(values.fechaVencimiento)}
              </span>
            </p>
          </div>
        )}
        {values.fechaOperacion && (
          <div className='tw-flex tw-flex-row tw-items-center'>
            <FontAwesomeIcon
              icon={["fal", "pen"]}
              className='tw-w-4 tw-h-4 tw-text-text !tw-cursor-pointer tw-mr-3 hover:!tw-text-secondary'
              onClick={() =>
                setFieldValue(
                  "modals.showFechaOperacionModal",
                  !values.modals.showFechaOperacionModal
                )
              }
            />
            <p className='tw-m-0 tw-text-base'>
              {t("crear.facturaRec.opertationDateLabel")}
              <span className='tw-font-bold'>
                {formatDate(values.fechaOperacion)}
              </span>
            </p>
          </div>
        )}
      </div>
      <AnimatePresence>
        <Modal
          key='modal-fecha-emision'
          header={t("crear.facturaRec.modal.newField")}
          size='small'
          onHide={() => setFieldValue("modals.showFechaEmisionModal", false)}
          visible={values.modals.showFechaEmisionModal}
        >
          <FormFechaEmision
            onChange={(value: string) => {
              setFieldValue("fechaEmision", value)
            }}
            fechaEmision={values?.fechaEmision}
            onHide={() => setFieldValue("modals.showFechaEmisionModal", false)}
          />
        </Modal>
        <Modal
          key='modal-fecha-vencimiento'
          header={t("crear.facturaRec.modal.newField")}
          size='small'
          onHide={() =>
            setFieldValue("modals.showModalFechaVencimiento", false)
          }
          visible={values.modals.showModalFechaVencimiento}
        >
          <FormFechaVencimiento
            onChange={(value: string) => {
              setFieldValue("fechaVencimiento", value)
            }}
            fechaVencimiento={values?.fechaVencimiento}
            fechaEmision={values?.fechaEmision}
            onHide={() =>
              setFieldValue("modals.showModalFechaVencimiento", false)
            }
          />
        </Modal>
        <Modal
          key='modal-fecha-operacion'
          header={t("crear.facturaRec.modal.newField")}
          size='small'
          onHide={() => setFieldValue("modals.showFechaOperacionModal", false)}
          visible={values.modals.showFechaOperacionModal}
        >
          <FormFechaPagoOperacion
            onChange={(value: string) => {
              setFieldValue("fechaOperacion", value)
            }}
            typeDocument={values.documentoType.type}
            fechaEmision={values?.fechaEmision}
            fechaOperacion={values?.fechaOperacion}
            onHide={() =>
              setFieldValue("modals.showFechaOperacionModal", false)
            }
          />
        </Modal>
      </AnimatePresence>
    </div>
  )
}

export default HeaderDatesLogoDocument
